<div class="container mb-5" style="margin-top: 105px">
  <div class="row g-0 gx-lg-0 breadcrumb-wrapper">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <app-breadcrumb *ngIf="showBreadCrumb"></app-breadcrumb>
    </div>

  </div>
    <div class="d-flex justify-content-between align-items-center flex-wrap">
        <div class="heading">
            <p style="font-size: 2rem; font-weight: 600;">
                Select value-added services for applications selected
            </p>
        </div>
        <div class="select-another p-2" (click)="backToAmcBookingList()">
            Select another segment
        </div>
    </div>
    <div class="step-container">
        <div class="step">
            <div class="step-icon completed">✓</div>
            <div class="step-line"></div>
            <div class="step-icon pending">2</div>
        </div>
        
        <div class="step">
            <span class="description">Select AMC plan for Construction Aggregates</span>
            <span class="description">Select add-on and Tenure for Construction Aggregates</span>
        </div>
    </div>
  <div class="addition-service my-3">
    <p style="font-size: 20px; font-weight: 600;"> Additional Service</p>
  </div>
  <div class="d-flex flex-wrap my-3" style="gap: 30px">
    <div class="row" *ngFor="let data of extendedArrayData">
      <div class="col-md-3 card p-3" style="height: 143px; width: 318px; margin: 5px;">
        <div class="d-flex">
          <input
            type="checkbox"
            style="height: 24px; width: 24px"
            step="warranty"
            (change)="getExtendedVas($event,data)"
            [checked]="selectedExtendedWarranty[data?.plan] || false"
          />
          <label for="warranty" class="ms-2">
            <strong class="label-color">{{ data?.plan }}</strong>
          </label>
        </div>
        <p class="label-price mt-3">
          {{ data?.price_per_year ? (data?.price_per_year | currency:'INR':'symbol':'4.0-0') : '-' }}
        </p>
      </div>
    </div>
  </div>
 

  <div class="rangeContainer">
    <div class="reportInRange">
      <div class="slider-container">
        <div class="d-flex flex-column" *ngIf="isHCV">
          <label for="rangeSlider1" class="chasis_no" style="color: #666C84;">
            Annual running hours (in Hrs)
          </label>
          <span style="color: navy;padding-top: 10px;">{{ annualRunningHours | number: '1.0-0' }} hrs</span>
        </div>
        <div  class="d-flex flex-column" *ngIf="!isHCV">
          <label for="rangeSlider1" class="chasis_no" style="color: #666C84;">
            Annual running KMS (in Km)
          </label>
          <span style="color: navy;padding-top: 10px;">{{ annualRunningHours | number: '1.0-0' }} KMS</span>
        </div>
        <!-- <ngx-slider id="rangeSlider1" class="mt-5" [(value)]="annualRunningHours" [options]="annualRunningHoursOptions"></ngx-slider> -->
      </div>
    </div>
    
    <div class="reportInRange">
      <div class="slider-container">
        <div class="d-flex flex-column amcDuration">
          <label for="rangeSlider2" class="chasis_no" style="color: #666C84;">
            Duration of AMC
          </label>
          <span style="color: navy;padding-top: 10px;">{{ (amcDuration / 12) | number: '1.0-1' }} Years</span>
        </div>
        <!-- <ngx-slider id="rangeSlider2" class="mt-5" [(value)]="amcDuration" [options]="amcDurationOptions"></ngx-slider> -->
      </div>
    </div>
  </div>
  
</div>
<div class="container-fluid payment-section d-flex justify-content-between flex-wrap" style="bottom: 0; background-color: white; width: 100%;position: sticky;bottom: 0;overflow: hidden;">
  <div class="container totalAmtAndBookingSection" >
    <div class="mt-4 ps-1">
        <span class="price-info">
           {{ selectedPrice ? (selectedPrice | currency:'INR':'symbol':'4.0-0') : '-'}}
        </span>
      <p>Total Amount to be paid</p>
    </div>
    <div class="text-center my-4">
      <button
        type="button" (click)="submitData()"
        class="btn btn-primary btn-lg btn-grad-primary btn-brand me-1 submitbtn"
      >
        Continue Booking with VAS
      </button>
    </div>
  </div>
</div>

